<template>
    <div class="content-page">
        <div class="bd">
            <div class="tab-header">
                <div class="header-left">
                    <el-button type="primary" size="small" @click="dialogVisible = true; openType = `新增楼宇`">
                        新增楼宇
                    </el-button>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="list">
                <el-table :data="floorList" style="width: 100%;">
                    <el-table-column label="楼宇名称">
                        <template slot-scope="scope">
                            <div>{{ scope.row.name }}</div>
                        </template>
                    </el-table-column>

                    <el-table-column label="楼层">
                        <template slot-scope="scope">
                            <div>{{ scope.row.floorNum }}</div>
                        </template>
                    </el-table-column>

                    <el-table-column label="餐厅">
                        <template slot-scope="scope">
                            <div>{{ showCanteenName[scope.row.restaurantId] || scope.row.restaurantId }}</div>
                        </template>
                    </el-table-column>

                    <el-table-column label="配送员">
                        <template slot-scope="scope">
                            <div>{{ showManagerName[scope.row.sendWorkUserId] || scope.row.sendWorkUserId }}</div>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" header-align="right">
                        <template slot-scope="scope">
                            <div class="float-right">
                                <el-button size="small" type="primary" @click="handleEdit(scope.row)">
                                    编辑
                                </el-button>

                                <el-button size="small" type="danger" @click="handleDelete(scope.row)">
                                    删除
                                </el-button>

                                <el-button size="small" type="primary" plain @click="handleDetail(scope.row)">
                                    详情
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :page-size="pageSize" :current-page="pageNo" background layout="prev, pager, next, jumper"
                        :total="pageCount">
                    </el-pagination>
                </div>
            </div>
        </div>

        <el-dialog :title="openType" :visible.sync="dialogVisible" :close-on-click-modal="false"
            :close-on-press-escape="false" :append-to-body="true" width="30%">

            <div>
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="楼宇名称">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>

                    <el-form-item label="楼层">
                        <div class="form-item-container">
                            <el-input-number v-model="form.floorNum" controls-position="right" :min="1"
                                :max="35"></el-input-number>
                        </div>
                    </el-form-item>

                    <el-form-item label="餐厅">
                        <div class="form-item-container">
                            <el-select v-model="form.restaurantId" filterable placeholder="请选择餐厅"
                                v-el-select-lazyloading="lazyloading">
                                <el-option v-for="canteen in canteenList" :label="canteen.name"
                                    :value="canteen.restaurantId" :key="canteen.restaurantId"></el-option>
                            </el-select>
                        </div>
                    </el-form-item>

                    <el-form-item label="配送员">
                        <div class="form-item-container">
                            <el-select v-model="form.sendWorkUserId" filterable placeholder="请选择配送员">
                                <el-option v-for="manage in managerList" :label="manage.fullName"
                                    :value="manage.shopWorkerUserId" :key="manage.shopWorkerUserId"></el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                </el-form>
            </div>


            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCancel()">取 消</el-button>
                <el-button type="primary" @click="handleAdd()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：Api，工具js，第三方插件js，json文件，图片文件等等）
import { findShopWorks, getFloorList, getFloorListCount, getCanteenList, editFloor, deleteFloor } from "@/api";
//例如：import 《组件名称》 from '《组件路径》'

export default {
    components: {},
    props: [],
    directives: {
        "el-select-lazyloading": {
            bind(el, binding) {
                let SELECT_DOM = el.querySelector(
                    ".el-select-dropdown .el-select-dropdown__wrap"
                );
                SELECT_DOM.addEventListener("scroll", function () {
                    let condition =
                        this.scrollHeight - this.scrollTop <= this.clientHeight;
                    if (condition) {
                        binding.value();
                    }
                });
            },
        },
    },
    data() {
        return {
            floorList: [],
            canteenList: [],
            managerList: [],

            pageNo: 1,
            pageSize: 5,
            pageCount: 0,

            openType: "新增楼宇",
            dialogVisible: false,

            form: {
                buildingId: '',
                name: '',
                floorNum: 1,
                restaurantId: '',
                sendWorkUserId: '',
            },

            loading: false,
            canteenPageNo: 1,
            canteenPageRow: 20,

            showCanteenName: {},
            showManagerName: {},
        };
    },
    computed: {},
    watch: {},

    async mounted() {
        await this.getManagerList(); // 获取配送员
        await this.lazyloading(); // 获取餐厅列表 
        await this.getData(); // 获取楼宇列表
    },
    methods: {
        async getManagerList() {
            const res = await findShopWorks({ isAll: 1 });
            this.managerList = res.data;

            this.managerList.forEach(item => {
                this.showManagerName[item.shopWorkerUserId] = item.fullName;
            })
        },

        async getData() {
            const tempData = {
                pageNo: this.pageNo,
                row: this.pageSize,
            }
            const result = await getFloorListCount({});
            this.pageCount = result.data || 1;
            let res = await getFloorList(tempData);
            this.floorList = res.data;
        },

        // 下拉框懒加载
        async lazyloading() {
            if (this.loading) return;

            this.loading = true;
            let tempData = {
                pageNo: this.canteenPageNo,
                row: this.canteenPageRow,
            }
            const res = await getCanteenList(tempData);

            // 如果没有数据直接return
            if (!res.data) {
                return
            }
            this.loading = false;
            this.canteenList.push(...res.data);
            this.canteenPageNo++;

            // 配置展示餐厅名称
            this.canteenList.forEach(item => {
                this.showCanteenName[item.restaurantId] = item.name;
            })
        },

        // 新增
        async handleAdd() {
            if (this.form.name == '') {
                this.$message({
                    type: 'error',
                    message: `请输入楼宇名称`
                });

                return
            }
            if (this.form.restaurantId == '') {
                this.$message({
                    type: 'error',
                    message: `请选择餐厅`
                });

                return
            }
            if (this.form.sendWorkUserId == '') {
                this.$message({
                    type: 'error',
                    message: `请选择配送员`
                });

                return
            }

            const res = await editFloor(this.form);
            if (res.code == 1) {
                this.$message({
                    type: 'success',
                    message: `操作成功`
                });

                this.dialogVisible = false;
                this.form = {
                    buildingId: '',
                    name: '',
                    floorNum: 1,
                    restaurantId: '',
                    sendWorkUserId: '',
                }

                // 更新列表
                this.getData()
            } else {
                this.$message({
                    type: 'error',
                    message: `${res.msg}`
                });
            }
        },

        // 编辑
        handleEdit(data) {
            console.log(data);
            this.form.buildingId = data.buildingId;
            this.form.name = data.name;
            this.form.floorNum = data.floorNum;
            this.form.restaurantId = data.restaurantId;
            this.form.sendWorkUserId = data.sendWorkUserId;

            this.openType = "编辑餐厅";
            this.dialogVisible = true;
        },

        // 删除
        handleDelete(data) {
            this.$confirm('确认是否删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const tempData = {
                    buildingId: data.buildingId
                }
                await deleteFloor(tempData)

                this.pageNo = Math.ceil((this.pageCount - 1) / this.pageSize);

                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });

                // 更新列表
                this.getData()
            }).catch(() => {
            });
        },

        // 详情
        handleDetail(data) {
            this.$router.push({
                path: `/shop/floorDetail?floorInfo=${JSON.stringify(data)}`,
            });
        },

        // 取消
        handleCancel() {
            this.dialogVisible = false;
            this.form = {
                buildingId: '',
                name: '',
                floorNum: 1,
                restaurantId: '',
                sendWorkUserId: '',
            }
        },

        handleSizeChange() { },

        handleCurrentChange(value) {
            this.pageNo = value;
            this.getData();
        }
    },
};
</script>

<style lang="less" scoped>
.list {
    width: 100%;
    padding: 0 20px;
}

.pagination {
    display: flex;
    justify-content: center;
    align-self: center;
}

.form-item-container {
    width: 100%;
    display: flex;
}

:deep(.el-select) {
    flex: 1;
}

:deep(.el-input-number) {
    flex: 1;
}
</style>